import React from 'react';
import { Main } from './components';

const Invoices = () => <Main />;

export default Invoices;
